<a [href]="href()">
    <section class="button-wrapper" [ngClass]="{
      'background-1': type() === DownloadType.USER_MANUALS,
      'background-2': type() === DownloadType.CATALOG,
      'background-3': type() === DownloadType.HOW_TO_GUIDE,
      'background-4': type() === DownloadType.PRICE_LIST
    }">
        <div class="d-flex flex-row justify-content-between align-items-center">
            <h2>{{ label() }}</h2>
            <img [src]="IMAGE_URLS.docsDownloadIcon" class="download-icon" />
        </div>
    </section>
</a>